import { FundFrequency } from "../enums";

export const FundFrequencies = [
  { name: 'Annually', value: FundFrequency.Annually },
  { name: 'Daily', value: FundFrequency.Daily },
  { name: 'Monthly', value: FundFrequency.Monthly },
  { name: 'One Time', value: FundFrequency.OneTime },
  { name: 'Quarterly', value: FundFrequency.Quarterly },
  { name: 'Varies', value: FundFrequency.Varies },
  { name: 'Weekly', value: FundFrequency.Weekly },
];
